import { render, staticRenderFns } from "./TipoConsulta.vue?vue&type=template&id=5c95c6dc"
import script from "./TipoConsulta.vue?vue&type=script&lang=js"
export * from "./TipoConsulta.vue?vue&type=script&lang=js"
import style0 from "./TipoConsulta.vue?vue&type=style&index=0&id=5c95c6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports